import React, { Component } from "react";
import { Link } from "react-router-dom";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";

import Divider from "@material-ui/core/Divider";
import Button from "@material-ui/core/Button";

class Side_Nav extends Component {
  state = {
    showFullNav: true,
    showMediumNav: false,
    toggleNavVis: false,
    usingMobileNav: false
  };

  componentDidMount() {
    window.addEventListener("resize", this.changeNav);
    window.addEventListener("load", this.changeNav);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.changeNav);
    window.removeEventListener("load", this.changeNav);
  }

  changeNav = e => {
    if (window.innerWidth >= 1030) {
      this.setState({ showFullNav: true });
    } else {
      this.setState({ showFullNav: false, showMediumNav: true });
    }
    if (window.innerWidth <= 768) {
      this.setState({ usingMobileNav: true, showMediumNav: false });
    }
  };

  toggleNav = e => {
    e.preventDefault();
    let { toggleNavVis } = this.state;
    this.setState({ toggleNavVis: !toggleNavVis });
  };

  toggleNavItem = e => {
    this.setState({ toggleNavVis: false });
  };

  render() {
    return this.state.showFullNav ? (
      <nav className="admin-nav">
        <List>
          <ListItem button>
            <Link className="sidenav-btn" to="/">
              Front End
            </Link>
          </ListItem>
          <Divider className="divider" />
          <ListItem button>
            <Link className="sidenav-btn" to="/admin">
              Dashboard
            </Link>
          </ListItem>
          <Divider className="divider" />
          <ListItem button>
            <Link className="sidenav-btn" to="/admin/pages">
              Pages
            </Link>
          </ListItem>
          <Divider className="divider" />
          <ListItem button>
            <Link className="sidenav-btn" to="/admin/images">
              Media Library
            </Link>
          </ListItem>
          <Divider className="divider" />
          <ListItem button>
            <Link className="sidenav-btn" to="/admin/banner">
              Banner Content
            </Link>
          </ListItem>
          <Divider className="divider" />
          <ListItem button>
            <Button
              variant="contained"
              color="secondary"
              onClick={this.props.logout}
            >
              Sign out
            </Button>
          </ListItem>
        </List>
      </nav>
    ) : this.state.showMediumNav ? (
      <nav className="medium-admin-nav">
        <AppBar position="static" color="default">
          <Toolbar>
            <Link className="sidenav-btn" to="/">
              Front End
            </Link>
            <Link className="sidenav-btn" to="/admin">
              Dashboard
            </Link>
            <Link className="sidenav-btn" to="/admin/pages">
              Pages
            </Link>
            <Link className="sidenav-btn" to="/admin/images">
              Media Library
            </Link>
            <Link className="sidenav-btn" to="/admin/banner">
              Banner Content
            </Link>
            <Button
              variant="contained"
              color="secondary"
              onClick={this.props.logout}
            >
              Sign out
            </Button>
          </Toolbar>
        </AppBar>
      </nav>
    ) : (
      <nav className="mobile-admin-nav">
        <AppBar position="static" color="default">
          <Link className="toggle-admin-nav" to="/" onClick={this.toggleNav}>
            <i className="fas fa-bars" />
          </Link>
          <Toolbar
            className={this.state.toggleNavVis ? "showMobileNav" : "hide"}
          >
            <Link className="sidenav-btn" to="/">
              Front End
            </Link>
            <Link
              className="sidenav-btn"
              to="/admin"
              onClick={this.toggleNavItem}
            >
              Dashboard
            </Link>
            <Link
              className="sidenav-btn"
              to="/admin/pages"
              onClick={this.toggleNavItem}
            >
              Pages
            </Link>
            <Link
              className="sidenav-btn"
              to="/admin/images"
              onClick={this.toggleNavItem}
            >
              Media Library
            </Link>
            <Link
              className="sidenav-btn"
              to="/admin/banner"
              onClick={this.toggleNavItem}
            >
              Banner Content
            </Link>
            <Button
              variant="contained"
              color="secondary"
              onClick={this.props.logout}
            >
              Sign out
            </Button>
          </Toolbar>
        </AppBar>
      </nav>
    );
  }
}

export default Side_Nav;



// WEBPACK FOOTER //
// ./src/admin/includes/Side_Nav.js